var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefinanceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5L16 8.5M16 8.5L12 4.5M16 8.5H12C7.58172 8.5 4 12.0817 4 16.5M36 36.5L32 40.5M32 40.5L36 44.5M32 40.5H36C40.4183 40.5 44 36.9183 44 32.5M20.3781 13.5C21.7102 8.32432 26.4085 4.5 32 4.5C38.6274 4.5 44 9.87258 44 16.5C44 22.0915 40.1757 26.7897 35.0001 28.1219M28 32.5C28 39.1274 22.6274 44.5 16 44.5C9.37258 44.5 4 39.1274 4 32.5C4 25.8726 9.37258 20.5 16 20.5C22.6274 20.5 28 25.8726 28 32.5Z",
    stroke: "#091DF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefinanceIcon);
export default __webpack_public_path__ + "static/media/refinance-icon.55543ad5bc151d82e4b4f8207a9d5e2f.svg";
export { ForwardRef as ReactComponent };